import { useTranslation } from "react-i18next";
import { hideProfile } from "../../../reducers/profile";
import { useAppDispatch, useAppSelector } from "../../../store";
import defaultContent from "../../../content/profile";
import { closeProfileClickTrack } from "../../../common/tealium/CustomerProfile/Profile/IndexTrack";
import LeafPanel from "../../../common/leaf/LeafPanel/LeafPanel";
import CustomerProfileBody from "./CustomerProfileBody/CustomerProfileBody";

const CustomerProfileSlider = () => {
  const { t } = useTranslation(["profile", "common"]);

  const dispatch = useAppDispatch();

  const isShowProfile = useAppSelector((state) => state.profile.isShowProfile);
  const profileType = useAppSelector((state) => state.profile.profileType);

  const showSlider = isShowProfile && profileType === "customer";

  const closeProfile = () => {
    dispatch(hideProfile());
    closeProfileClickTrack();
  };

  return (
    <>
      <LeafPanel
        title={`${t("customerProfile.title", defaultContent["customerProfile"]["title"])}`}
        show={showSlider}
        onCloseClick={closeProfile}
        id={"profile-slider"}
        applyScroll={true}
      >
        <CustomerProfileBody isShowProfile={showSlider} />
      </LeafPanel>
    </>
  );
};

export default CustomerProfileSlider;
